var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BankPicker',{attrs:{"tooltip":_vm.tooltip,"disabled":_vm.disabled},model:{value:(_vm.banks),callback:function ($$v) {_vm.banks=$$v},expression:"banks"}})}
var staticRenderFns = []

export { render, staticRenderFns }